import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDateSeparator } from '../util/format.js';
/** Центрированная плашка «Сегодня / Вчера / 12 июня»; sticky к верху ленты. */
export function DateSeparator({ date, now, sticky = true }) {
    const wrap = {
        display: 'flex',
        justifyContent: 'center',
        margin: 'var(--space-3) 0',
        ...(sticky
            ? { position: 'sticky', top: 'var(--space-1)', zIndex: 'var(--z-sticky)' }
            : {}),
    };
    const pill = {
        padding: '3px 12px',
        borderRadius: 'var(--radius-pill)',
        background: 'var(--color-bg-secondary)',
        color: 'var(--color-text-muted)',
        fontSize: 'var(--font-xs)',
        fontWeight: 'var(--weight-medium)',
    };
    return (_jsx("div", { "data-date-separator": "", style: wrap, children: _jsx("span", { style: pill, children: formatDateSeparator(date, now ?? new Date()) }) }));
}
/** Горизонтальная черта-метка «Непрочитанные»; ставится перед первым непрочитанным сообщением. */
export function UnreadDivider({ label = 'Непрочитанные' }) {
    const wrap = {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-3)',
        margin: 'var(--space-2) 0',
        color: 'var(--color-accent)',
        animation: 'tc-ds-fade-in var(--motion-normal) var(--ease-standard)',
    };
    const line = { flex: 1, height: '1px', background: 'var(--color-accent-muted)' };
    return (_jsxs("div", { "data-unread-divider": "", style: wrap, children: [_jsx("span", { style: line }), _jsx("span", { style: { fontSize: 'var(--font-xs)', fontWeight: 'var(--weight-medium)' }, children: label }), _jsx("span", { style: line })] }));
}
//# sourceMappingURL=Separators.js.map